<div class="form-container" style="position: relative;">
  <div class="loader" *ngIf="isLoading">
    <div class="spinner"></div>
  </div>
  <div *ngIf="success" class="alert alert-success mb-2 col-12 text-center">{{ success }}</div>
  <div *ngIf="error != null && (error != '' || loginForm.invalid) " class="mb-2 col-12 text-center alert alert-danger">
    {{ error }}</div>

  <!-- subscripe form -->
  <form [formGroup]="loginForm" (ngSubmit)="onLogin()" *ngIf="isLogin">
    <span class="subscripe-text">{{ "SUBSCRIPTION_TEXT" | translate }}</span>
    <div class="form-group">

      <div class="input-group" style="direction: ltr;">
        <div class="input-group-prepend">
          <span class="input-group-text number-text" id="basic-addon2"
            style="height: 100%; border-top-right-radius: 0; border-bottom-right-radius: 0;">+218</span>
        </div>
        <input type="text" class="form-control" id="phone" formControlName="phone" aria-describedby="Phone number"
          [placeholder]="'PHONE_PLACEHOLDER' | translate" (input)="allowOnlyNumbers($event)" style="direction: ltr;" />
      </div>

      <div *ngIf="loginForm.get('phone')?.invalid && (loginForm.get('phone')?.dirty || loginForm.get('phone')?.touched)"
        class="alert">
        <ng-container *ngIf="loginForm.get('phone')?.errors as errors">
          <span *ngIf="!errors['required'] && errors['minlength']" class="text-danger number-text">
            {{ "PHONE_DIGITS" | translate }}
          </span>
          <span *ngIf="!errors['required'] && !errors['minlength'] && errors['validatePhoneOtherNetwork']"
            class="text-danger number-text">
            {{ "SERVICE_NOT_AVAILABLE_MSG" | translate }}
          </span>
          <span
            *ngIf="!errors['required'] && !errors['minlength'] && !errors['validatePhoneOtherNetwork'] && errors['validateInput']"
            class="text-danger number-text">
            {{ "PHONE_PATTERN" | translate }}
          </span>
          <span *ngIf="!errors['touched'] && errors['required']" class="text-danger number-text">
            {{ "PHONE_TOUCHED" | translate }}
          </span>
        </ng-container>
      </div>
    </div>

    <button type="submit" id="cta_button" [disabled]="isSubmitting || loginForm.invalid"
      class="btn btn-primary mt-2 submit_btn">{{
      isSubmitting ? ("LOADING"
      | translate) : ("CONTINUE_SUBSCRIPTION" | translate) }}</button>
  </form>
  <!-- end subscripe form -->

  <!-- ----------------------------------------------------------------------------------------------------------- -->

  <!-- select package form -->
  <form [formGroup]="packageForm" (ngSubmit)="onSubscripe()" *ngIf="isSelectPackage">
    <span class="subscripe-number">{{ this.loginForm.get('phone')?.value }}</span>
    <span class="select-package-msg">{{ "SELECT_PACKAGE_MSG" | translate }}
      <span style="font-weight: bold;">
        {{ ((this.loginForm.get('phone')?.value?.startsWith('91') ||
        this.loginForm.get('phone')?.value?.startsWith('091') ||
        this.loginForm.get('phone')?.value?.startsWith('93') || this.loginForm.get('phone')?.value?.startsWith('093')) ?
        "MARAD_TITLE" : "LIBYANA") |
        translate }}
      </span>
    </span>
    <div class="row">
      <ng-container *ngFor="let package of availablePackages">
        <div class="col-sm-12 col-md-6">
          <div class="package-card">
            <p-radioButton formControlName="package" [value]="package?.id"></p-radioButton>
            <div class="package-data">
              <img src="../../../assets/images/package-icon.svg" alt="">
              <h3 class="package-name">
                {{ translate.currentLang == "en" ? package.nameEn : package.nameAr }}
              </h3>
              <h4 class="package-price">
                <span class="number-text">{{ package.price }}</span>
                {{ package.currency | translate }}
              </h4>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
    <button type="submit" id="cta_button" [disabled]="isSubmitting || packageForm.invalid"
      class="btn btn-primary mt-2 submit_btn">{{
      isSubmitting ? ("LOADING"
      | translate) : ("SUBMIT" | translate) }}</button>
  </form>
  <!-- end select package form -->

  <!-- ----------------------------------------------------------------------------------------------------------- -->

  <!-- unsubscripe form -->
  <form [formGroup]="unsubscribeForm" (ngSubmit)="onUnsubscribe()" *ngIf="isunsubscribe">
    <span class="subscripe-text">{{ "UNSUBSCRIPE_TEXT" | translate }}</span>

    <div class="form-group">
      <div class="input-group" style="direction: ltr;">
        <div class="input-group-prepend">
          <span class="input-group-text number-text" id="basic-addon2"
            style="height: 100%; border-top-right-radius: 0; border-bottom-right-radius: 0;">+218</span>
        </div>
        <input type="text" class="form-control" id="phone" formControlName="phone" aria-describedby="Phone number"
          [placeholder]="'PHONE_PLACEHOLDER' | translate" (input)="allowOnlyNumbers($event)" style="direction: ltr;" />
      </div>
      <div
        *ngIf="unsubscribeForm.get('phone')?.invalid && (unsubscribeForm.get('phone')?.dirty || unsubscribeForm.get('phone')?.touched)"
        class="alert">
        <ng-container *ngIf="unsubscribeForm.get('phone')?.errors as errors">
          <span *ngIf="!errors['required'] && errors['minlength']" class="text-danger number-text">{{ "PHONE_DIGITS" |
            translate
            }}</span>
          <span *ngIf="!errors['required'] && !errors['minlength'] && errors['validateInput']"
            class="text-danger number-text">{{
            "PHONE_PATTERN" | translate }}</span>
        </ng-container>
      </div>
    </div>

    <button type="submit" [disabled]="isSubmitting || unsubscribeForm.invalid"
      class="btn btn-primary mt-2 submit_btn">{{ isSubmitting ? ("LOADING"
      | translate) : ("SUBMIT" | translate) }}</button>
  </form>
  <!-- end unsubscripe form -->

  <!-- ----------------------------------------------------------------------------------------------------------- -->

  <!-- if subscribed  -->
  <div class="align-items-center" *ngIf="subscribed && !subscripeSuccess">
    <h2 class="operator-head">
      {{(phoneNumber?.startsWith('21893') || phoneNumber?.startsWith('21891') ? "ELMADAR" : "LIBYANA") |
      translate}}
    </h2>
    <div class="d-flex mb-3">
      <img class="subscribed-image" src="../../../assets/images/subscribed.svg">
      <span class="subscripe-text m-0">
        {{ "ALREADY_SUBSCRIPED" | translate }} {{ subscription_name }}
      </span>
    </div>
    <div class="button-container">
      <a class="cancel-btn" (click)="onCancel()" style="cursor: pointer;">{{ "CANCEL" | translate }}</a>
    </div>
  </div>
  <!-- end if subscribed  -->

  <!-- Subscripe success -->
  <div class="d-flex flex-column align-items-center justify-content-center" *ngIf="subscripeSuccess">
    <img src="assets/images/checkbox-circle-fill.svg" alt="">
    <h2 class="success-head">
      {{ "SUBSCRIPE_SUCCESS" | translate }} {{ subscription_name }}
    </h2>
    <ng-container *ngIf="is_user">
      <div class="d-flex mb-3">
        <!-- <span class="success-text m-0" *ngIf="operatingSystem != 'web'">
          {{ "REDIRECT_USER_MSG" | translate }}
        </span> -->
        <span class="success-text m-0">
          {{ "DOWNLOAD_APP_NOTE" | translate }}
        </span>
      </div>
      <div class="app-links">
        <a href="https://apps.apple.com/eg/app/hidaya-libya/id6742405750?l=ar" target="_blank" class="ms-2">
          <img src="../../../assets/images/app-store.png" alt="">
        </a>
        <a href="https://play.google.com/store/apps/details?id=com.hidayalibya&hl=en" target="_blank">
          <img src="../../../assets/images/google-play.png" alt="">
        </a>
      </div>
    </ng-container>

    <ng-container *ngIf="!is_user">
      <div class="d-flex flex-column align-items-center justify-content-center mb-3">
        <span class="success-text m-0">
          {{ "REDIRECT_NEW_USER_MSG" | translate }}
        </span>
        <div class="d-flex flex-column align-items-center justify-content-center mb-4">
          <span class="count-down number-text">{{ countdownDisplay }}</span>
          <span class="resend-text">{{ "DIDNOT_RECIEVE_PASSWORD" | translate }}</span>
          <a class="resend-action" style="cursor: pointer;" [class.disabled]="countdownDisplay !== '00:00'"
            (click)="countdownDisplay === '00:00' && resendPassword()">{{ "RESEND_PASSWORD" | translate }}</a>
        </div>
        <span class="success-text m-0">
          {{ "DOWNLOAD_APP_NOTE" | translate }}
        </span>
      </div>
      <div class="app-links">
        <a href="https://apps.apple.com/eg/app/hidaya-libya/id6742405750?l=ar" target="_blank" class="ms-2">
          <img src="../../../assets/images/app-store.png" alt="">
        </a>
        <a href="https://play.google.com/store/apps/details?id=com.hidayalibya&hl=en" target="_blank">
          <img src="../../../assets/images/google-play.png" alt="">
        </a>
      </div>
    </ng-container>
  </div>
  <!-- end Subscripe success -->

  <!-- Expired supscription -->
  <div class="d-flex flex-column align-items-center justify-content-center" *ngIf="subscriptionExpired">
    <img src="assets/images/expired.svg" alt="">
    <h2 class="expired-head">
      {{ "SUBSCRIPE_EXPIRE" | translate }}
    </h2>
    <button type="button" class="btn btn-primary mt-2 submit_btn" (click)="returnToMain()">
      {{ "HOME" | translate }}
    </button>
  </div>
  <!-- End Expired supscription -->
</div>

<div class="col-12 d-flex flex-column align-items-center justify-content-center mt-4" *ngIf="isLogin || subscribed">
  <span class="subscripe-note-main mb-4">{{ "SUBSCRIPE_NOTE_MAIN" | translate }}</span>
  <span class="subscripe-note-sub mb-2">{{ "SUBSCRIPE_NOTE_SUB" | translate }}</span>
  <a class="terms-link" routerLink="/terms-conditions">{{ "TERMS_CONDITIONS" | translate }}</a>
</div>
<!-- -------------------------------------------------------------------------------------------------------------------------- -->
<!-- subscribe confrimation dialog -->
<p-dialog class="dialog" [(visible)]="isLoginConfirm" [modal]="true" (onHide)="hideOtpPopup()"
  [style]="{width: '642px', 'border-radius': '12px', overflow: 'hidden'}" [baseZIndex]="10000">
  <ng-template pTemplate="content">
  </ng-template>

  <div *ngIf="successOTP" class="alert alert-success mb-2 col-12 text-center">{{ successOTP }}</div>
  <div *ngIf="errorOTP" class="mb-2 col-12 text-center alert alert-danger">{{ errorOTP }}</div>

  <form (ngSubmit)="onLoginConfirm(authForm)" #authForm="ngForm">
    <div class="dialog-msg-container">
      <span class="otp-dialog-label">{{ "OTP_DIALOG_LABEL" | translate }}</span>
      <span class="otp-dialog-msg">
        {{ "OTP_DIALOG_MSG1" | translate }} <br>
        {{ phoneMask || "XXXXXXX90" }}
      </span>
      <span class="otp-dialog-msg">
        {{ "OTP_DIALOG_MSG2" | translate }}
        {{(this.loginForm.get('phone')?.value?.startsWith('93') ||
        this.loginForm.get('phone')?.value?.startsWith('091') ||
        this.loginForm.get('phone')?.value?.startsWith('093') ||
        this.loginForm.get('phone')?.value?.startsWith('91') ? "OTP_DIALOG_MSG2_ELMADAR_PACKAGE" :
        "OTP_DIALOG_MSG2_LIBYANA_PACKAGE") |
        translate}}
      </span>
    </div>

    <div class="otp-form-container">
      <div class="form-group otp-fg">
        <p-inputOtp [(ngModel)]="otpValue" (ngModelChange)="onOtpChange($event)" name="otpValue" *ngIf="otpVisible">
          <ng-template pTemplate="input" let-token let-events="events">
            <input class="p-inputtext p-component p-element p-inputotp-input" (input)="events.input($event)"
              (keydown)="events.keydown($event)" type="number" [value]="token" [maxLength]="1" name="otpValue"
              inputmode="numeric" #otpInput />
          </ng-template>
        </p-inputOtp>
      </div>
      <button type="submit" id="cta_button"
        [disabled]="isSubmitting || !this.otpValue || this.otpValue.toString().length < 4"
        class="btn btn-primary mt-2 submit_btn">{{
        isSubmitting ?
        ("LOADING" | translate) : ("SUBMIT" | translate) }}</button>

      <div class="d-flex flex-column align-items-center justify-content-center mb-4">
        <span class="count-down number-text">{{ countdownDisplay }}</span>
        <span class="resend-text">{{ "DIDNOT_RECIEVE_OTP" | translate }}</span>
        <a class="resend-action" style="cursor: pointer;" [class.disabled]="countdownDisplay !== '00:00'"
          (click)="countdownDisplay === '00:00' && onSubscripe()">{{ "RESEND_OTP" | translate }}</a>
      </div>
    </div>

  </form>
</p-dialog>
<!-- -------------------------------------------------------------------------------------------------------------------------- -->
<!-- Unsubscribe confrimation dialog -->
<p-dialog class="dialog" [(visible)]="isUnsubscribeConfirm" [modal]="true" (onHide)="hideOtpPopup()"
  [style]="{width: '642px', 'border-radius': '12px', overflow: 'hidden'}" [baseZIndex]="10000">
  <ng-template pTemplate="content">
  </ng-template>

  <div *ngIf="successOTP" class="alert alert-success mb-2 col-12 text-center">{{ successOTP }}</div>
  <div *ngIf="errorOTP" class="mb-2 col-12 text-center alert alert-danger">{{ errorOTP }}</div>

  <form (ngSubmit)="onUnsubscribeConfirm()" #authForm="ngForm">
    <div class="dialog-msg-container">
      <span class="otp-dialog-label">{{ "OTP_DIALOG_LABEL" | translate }}</span>
      <span class="otp-dialog-msg">
        {{ "OTP_DIALOG_MSG1" | translate }} <br>
        {{ phoneMask || "XXXXXXX90" }}
      </span>
      <span class="otp-dialog-msg">{{ "OTP_DIALOG_MSG2_UNSUBSCRIPE" | translate }}
        {{(this.loginForm.get('phone')?.value?.startsWith('93') ||
        this.loginForm.get('phone')?.value?.startsWith('091') ||
        this.loginForm.get('phone')?.value?.startsWith('093') ||
        this.loginForm.get('phone')?.value?.startsWith('91') ? "OTP_DIALOG_MSG2_ELMADAR_PACKAGE" :
        "OTP_DIALOG_MSG2_LIBYANA_PACKAGE") |
        translate}}
      </span>
    </div>

    <div class="otp-form-container">
      <div class="form-group otp-fg">
        <p-inputOtp [(ngModel)]="otpValue" (ngModelChange)="onOtpChange($event)" name="otpValue" *ngIf="otpVisible">
          <ng-template pTemplate="input" let-token let-events="events">
            <input class="p-inputtext p-component p-element p-inputotp-input" (input)="events.input($event)"
              (keydown)="events.keydown($event)" type="number" [value]="token" [maxLength]="1" inputmode="numeric" />
          </ng-template>
        </p-inputOtp>
      </div>
      <button type="submit" [disabled]="isSubmitting || !this.otpValue || this.otpValue.toString().length < 4"
        class="btn btn-primary mt-2 submit_btn">{{ isSubmitting ?
        ("LOADING" | translate) : ("SUBMIT" | translate) }}</button>

      <div class="d-flex flex-column align-items-center justify-content-center mb-4">
        <span class="count-down number-text">{{ countdownDisplay }}</span>
        <span class="resend-text">{{ "DIDNOT_RECIEVE_OTP" | translate }}</span>
        <a class="resend-action" style="cursor: pointer;" [class.disabled]="countdownDisplay !== '00:00'"
          (click)="countdownDisplay === '00:00' && onUnsubscribe()">{{ "RESEND_OTP" | translate }}</a>
      </div>
    </div>

  </form>
</p-dialog>
<!-- -------------------------------------------------------------------------------------------------------------------------- -->

<!-- Redirection popup -->
<p-dialog class="dialog" [(visible)]="isRedirectionPopupOpen" [modal]="true" (onHide)="hideRedirectionPopup()"
  [style]="{width: '642px', 'border-radius': '12px', overflow: 'hidden'}" [baseZIndex]="10000">
  <ng-template pTemplate="content">
    <div class="d-flex flex-column align-items-center justify-content-center">
      <img src="assets/images/checkbox-circle-fill.svg" alt="">
      <h2 class="success-head">
        {{ "SUBSCRIPE_SUCCESS" | translate }} {{ subscription_name }}
      </h2>
      <div class="d-flex mb-3 flex-column">
        <span class="success-text m-0">
          {{ "REDIRECT_LINK_MSG" | translate }}
          <a (click)="redirectToAppIOS()" class="app-link-redirect">{{ "OPEN_APP_LINK" | translate }}</a>
        </span>
        <span class="success-text m-0">
          {{ "DOWNLOAD_APP_NOTE" | translate }}
        </span>
      </div>
      <div class="app-links">
        <a href="https://apps.apple.com/eg/app/hidaya-libya/id6742405750?l=ar" target="_blank">
          <img src="../../../assets/images/app-store.png" alt="">
        </a>
      </div>
    </div>
  </ng-template>
</p-dialog>
<!-- Successfully subscribed or unsubscribed dialog -->
<p-confirmDialog #cd key="confirm">
  <ng-template pTemplate="message" let-message>
    <div class="d-flex flex-column align-items-center justify-content-center p-5 surface-overlay border-round mb-2"
      style="overflow-y: hidden;">
      <img class="dialog-icon" src="../../../assets/images/checkbox-circle-fill.svg">
      <span id="dialog-content" class="justify-content-center">
        {{ message.message }}
      </span>
    </div>
  </ng-template>
</p-confirmDialog>